import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import { NovelDetailsView } from '@/features/reader/components/NovelDetailsView';

export const Route = createFileRoute('/read/$novelId/')({
  component: NovelDetailsPage,
});

function NovelDetailsPage() {
  const { novelId } = Route.useParams();

  return (
    <AuthGuard>
      <NovelDetailsView novelId={novelId} />
    </AuthGuard>
  );
}
